import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=f0a0a380&scoped=true&"
import script from "./Perfil.vue?vue&type=script&lang=js&"
export * from "./Perfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a0a380",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Perfil.vue
// module id = 584
// module chunks = 0